import { data } from 'autoprefixer';
import React, { useEffect, useState } from 'react';

const OrderRow = ({order, handleDelete, handleStatus}) => {
    console.log(order);
    const{_id, serviceName, phone, price, email, customer, service, status}=order
    const[orderService, setOrderService]= useState([])

    useEffect(()=>{
      fetch(`https://genius-server-tau.vercel.app/services/${service}`)
      .then(res=> res.json())
      .then(data=>setOrderService(data) )

    },[service])




    return (
        <div>
            
      <tr>
      <th>
      <button onClick={()=>handleDelete(_id)} className="btn btn-circle">
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
</button>
        </th>
        <td>
          <div className="flex items-center space-x-3">
            <div className="avatar">
              <div className="rounded w-24 h-24">
              {
                orderService?.img &&  
                 <img src={orderService.img}alt="Avatar Tailwind CSS Component" />
              }
              </div>
            </div>
            <div>
              <div className="font-bold">{customer}</div>
              <div className="text-sm opacity-50">{phone}</div>
            </div>
          </div>
        </td>
        <td>
          {serviceName}
          <br/>
          <span className="badge badge-ghost badge-sm">{price}</span>
        </td>
        <td>Purple</td>
        <th>
          <button onClick={()=>handleStatus(_id)} className="btn btn-ghost btn-xs">{status? status : "pending"}</button>
        </th>
      </tr>
   
        </div>
    );
};

export default OrderRow;